// Tooltips
(() => {
  document
    .querySelectorAll(".shopify-section--text-with-icons-inline")
    .forEach((section) => {
      if (section.dataset.initialized) {
        return;
      }

      section.dataset.initialized = "true";

      section.querySelectorAll("span[data-translation]").forEach((item) => {
        tippy(item, {
          content: item.dataset.translation,
          animation: "scale-subtle",
        });
      });
    });
})();
